// extracted by mini-css-extract-plugin
export var box = "_1p-2";
export var checkboxControl = "_1p-0";
export var checkboxRow = "_1p-a";
export var checked = "_1p-3";
export var descriptionSpacer = "_1p-c";
export var disabled = "_1p-4";
export var icon = "_1p-8";
export var input = "_1p-1";
export var labelSpacer = "_1p-b";
export var large = "_1p-7";
export var medium = "_1p-6";
export var small = "_1p-5";
export var text = "_1p-9";